<template>
    <div class="pagination-container">
        <div class="pagination-bar">
            <div class="pagination-item" @click="actionBack">
                <img src="../../assets/images/arrow-left-icon-dark-grey.svg" alt="<-">
            </div>
            <pagination-item :number="numberActivePage"/>
            <div class="pagination-item" @click="actionNext">
                <img src="../../assets/images/arrow-right-icon-dark-grey.svg" alt="->">
            </div>
        </div>
    </div>
</template>

<script>
    import PaginationItem from "./PaginationItem";
    import {mapGetters, mapMutations} from "vuex";

    export default {
        name: "Pagination",
        components: {PaginationItem},
        props: {
            numberOfPage: {
                type: Number,
                default: 1
            },
        },
        computed: {
            ...mapGetters('app', {
                numberActivePage: 'getNumberActivePage'
            })
        },
        methods: {
            actionBack() {
                if (this.numberActivePage > 1) {
                    this.setNumberActivePage(this.numberActivePage - 1);
                }
            },
            actionNext() {
                if (this.numberActivePage < this.numberOfPage) {
                    this.setNumberActivePage(this.numberActivePage + 1);
                }
            },
            ...mapMutations('app', {
                setNumberActivePage: 'setNumberActivePage',
            })
        }
    }
</script>

<style lang="scss">
    @import "../scss/variables";

    .pagination-container {
        display: flex;
        justify-content: center;

        .pagination-bar {
            display: flex;

            .pagination-item {
                display: flex;
                justify-content: center;
                align-items: center;
                height: 36px;
                padding: 0 12px;
                background-color: $white-color;
                border-right: solid 1px $bg-color-2;
                box-sizing: border-box;
                color: $text-color-2;
                font-weight: lighter;
                font-size: $l-font-size;
                cursor: pointer;
                transition: $transition;
                user-select: none;

                &:not(.active):hover {
                    font-weight: normal;
                }

                /* &.active {
                    background-color: $main-color;
                    color: $white-color;
                    border-color: $main-color;
                } */

                &:first-child {
                    border-radius: $m-border-radius 0 0 $m-border-radius;
                }

                &:last-child {
                    border-radius: 0 $m-border-radius $m-border-radius 0;
                    border-left: 0;
                }

                & > img {
                    height: 16px;
                }
            }
        }
    }
</style>